<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-9">
              <el-radio v-model="form.type" :label="voucherTypeActivity"
                >ข่าวกิจกรรม</el-radio
              >
              <el-radio v-model="form.type" :label="voucherTypePrivilege"
                >ข่าวสิทธิพิเศษ</el-radio
              >
            </div>
            <div class="col-3 text-end">
              <sc-button variant="primary" @click="handleClickSave"
                >บันทึก</sc-button
              >
            </div>
          </div>
          <voucher-editor
            v-model="form"
            :image-url="imageUrl"
            :thumbnail="thumbnailUrl"
            :event-conditions="eventConditions"
            @setContent="updateContent($event)"
            @setEventConditions="updateEventConditions($event)"
          ></voucher-editor>
        </div>
        <div class="col-4">
          <voucher-preview
            v-model="form"
            :content-html="contentHtml"
            :image-url="imageUrl"
          ></voucher-preview>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import ScButton from "@/lib/components/ScButton"
import PageWrapper from "@/lib/components/PageWrapper"
import { baanRueJaiClient } from "@/dependencies"
import { uploadPublicFile, uploadImage } from "@/god"
import { isEmpty, isNil } from "ramda"
import { DateTime } from "luxon"
import { fromJSDateToOptionalISODate } from "@/lib/dateTime"
import { Radio } from "element-ui"
import { voucherType } from "@/lib/mapper"
import VoucherPreview from "../components/VoucherPreview"
import VoucherEditor from "../components/VoucherEditor"
import { toVoucherErrorMessage } from "../models/voucherErrorMessage"

export default {
  components: {
    PageWrapper,
    VoucherEditor,
    VoucherPreview,
    "el-radio": Radio,
    "sc-button": ScButton,
  },
  data() {
    const title = "เพิ่ม Ruejai Club Voucher Package"
    const form = {
      type: voucherType.ACTIVITY,
      title: "",
      content: {},
      imageFile: null,
      thumbnailFile: null,
      pdfFile: null,
      fileName: null,
      latitude: 0,
      longitude: 0,
      locationName: "",
      voucherAlbum: [],
      event: {
        type: "IMMEDIATE",
        registrationQuestion: null,
        usageType: "ACTIVITY",
        startActivateDate: "",
        endActivateDate: "",
        startUseDate: "",
        endUseDate: "",
        prefixCode: "SC",
        codes: [],
        quota: 1,
        totalReserve: 1,
        showBarcode: true,
        barcodeRemark: "แสดง code นี้กับเจ้าหน้าที่เพื่อรับสิทธิ์",
      },
    }
    const contentHtml = ""
    const imageUrl = null
    const thumbnailUrl = null
    const eventConditions = {
      haveRegistrationQuestion: false,
      codeType: "PREFIXED",
      quotaType: "LIMITED",
      showWaitingListOptions: false,
      haveWaitingList: false,
    }

    return {
      title,
      form,
      contentHtml,
      imageUrl,
      thumbnailUrl,
      eventConditions,
    }
  },
  computed: {
    voucherTypeActivity() {
      return voucherType.ACTIVITY
    },
    voucherTypePrivilege() {
      return voucherType.PRIVILEGE
    },
  },
  watch: {
    form(form, oldForm) {
      if (this.form.imageFile !== oldForm.imageFile) {
        this.imageUrl = URL.createObjectURL(this.form.imageFile)
      }

      if (this.form.thumbnailFile !== oldForm.thumbnailFile) {
        this.thumbnailUrl = URL.createObjectURL(this.form.thumbnailFile)
      }
    },
    eventConditions() {
      if (!this.eventConditions.haveRegistrationQuestion) {
        this.form.event.registrationQuestion = null
      }
    },
  },
  created() {},
  methods: {
    updateContent(newContent) {
      this.form.content = newContent.contentJson
      this.contentHtml = newContent.contentHtml
    },
    updateEventConditions(newEventConditions) {
      this.eventConditions = newEventConditions
    },
    async handleClickSave() {
      if (isNil(this.form.imageFile)) {
        this.$message.error("ไม่สามารถบันทึกได้เนื่องจากไม่มีรูปปก")
        return
      }
      if (isNil(this.form.thumbnailFile)) {
        this.$message.error("ไม่สามารถบันทึกได้เนื่องจากไม่มีรูป thumbnail")
        return
      }

      try {
        await this.createVoucher()

        this.$router.push({ name: "RuejaiClubVoucherPackageListPage" })
      } catch (error) {
        this.$message.error(
          toVoucherErrorMessage(error, "ไม่สามารถสร้าง Voucher ได้"),
        )
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    async createVoucher() {
      const {
        type,
        title,
        content,
        imageFile,
        thumbnailFile,
        pdfFile,
        fileName,
        latitude,
        longitude,
        locationName,
        voucherAlbum,
        event,
      } = this.form

      const { codeType, quotaType, haveWaitingList, showWaitingListOptions } =
        this.eventConditions

      const coverImage = imageFile
        ? await uploadImage(imageFile, "", "article")
        : this.imageUrl
      const thumbnailImage = thumbnailFile
        ? await uploadImage(thumbnailFile, "", "article")
        : this.thumbnailUrl
      const album = !isEmpty(voucherAlbum)
        ? await Promise.all(
            voucherAlbum.map((albumFile) =>
              uploadImage(albumFile, "", "article"),
            ),
          )
        : null
      const fileUrl = !isNil(pdfFile)
        ? await uploadPublicFile(pdfFile, "article")
        : null
      const codes = codeType === "PREDEFINED" ? event.codes : null
      const quota = quotaType === "LIMITED" ? event.quota : null
      const totalReserve =
        haveWaitingList && showWaitingListOptions ? event.totalReserve : null
      const startActivateDate = fromJSDateToOptionalISODate(
        event.startActivateDate,
      )
      const endActivateDate = fromJSDateToOptionalISODate(event.endActivateDate)
      const startUseDate = fromJSDateToOptionalISODate(event.startUseDate)
      const endUseDate = fromJSDateToOptionalISODate(event.endUseDate)

      const params = {
        type: +type,
        title,
        content: JSON.stringify(content.ops),
        coverImage,
        thumbnailImage,
        projectId: [],
        clentRole: [],
        fileUrl,
        fileName,
        latitude: !isEmpty(locationName) ? latitude : null,
        longitude: !isEmpty(locationName) ? longitude : null,
        locationTitle: !isEmpty(locationName) ? locationName : null,
        album,
        privilege: {
          type: event.type,
          question: event.registrationQuestion,
          usageType: event.usageType,
          startActivateDate,
          endActivateDate,
          startUseDate,
          endUseDate,
          prefixCode: event.prefixCode,
          codes,
          quota,
          totalReserve,
          showBarcode: event.showBarcode,
          barcodeRemark: event.barcodeRemark || null,
        },
      }
      const articleParams = {
        publishAt: DateTime.utc().toISO(),
        tag: [],
      }

      const articleResponse = await baanRueJaiClient.admin.articles.post(params)
      const articleId = articleResponse.data.articles_id

      await baanRueJaiClient.admin.articles.postRequest(
        articleId,
        articleParams,
      )
      await baanRueJaiClient.admin.articles.postPublish(
        articleId,
        articleParams,
      )
      await baanRueJaiClient.admin.ruejaiClub.voucherPackages.post({
        article_id: articleId,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}
</style>
